export default __webpack_public_path__ + "static/media/aks-1.0ace2be7.jpg";